<template>
	<div class="d-flex align-center flex-wrap flex-grow-1 mx-2" style="gap: 6px">
		<button
			class="action-btn btn-new"
			v-if="checkPermissions(['create_users'])"
			@click="$store.usersStore.commit('setNewUserModal', true)"
			title="Nuevo Usuario"
		>
			<v-icon size="16" color="white">mdi-account-plus-outline</v-icon>
			<div class="d-flex flex-column align-items-start text-left" style="line-height: 1;">
				<p class="mb-0">Crear Nuevo</p>
				<p class="mb-0" style="font-size: 10px;opacity: 0.6;">Usuario</p>
			</div>
		</button>
		<button
			class="action-btn btn-export"
			v-if="checkPermissions(['create_users'])"
			@click="exportUsers()"
			title="Exportar Usuarios"
		>
			<v-icon size="16" color="white">mdi-download-outline</v-icon>
			<div class="d-flex flex-column align-items-start text-left" style="line-height: 1;">
				<p class="mb-0">Exportar</p>
				<p class="mb-0" style="font-size: 10px;opacity: 0.6;">Usuarios</p>
			</div>
		</button>
	</div>
</template>
<script>
import {projectUserExport} from '@/helpers/api/exports'
import {checkPermissions} from '@/helpers/permissions'

export default {
	name: 'UserActionButtons',
	data: () => ({
		//
	}),
	methods: {
		checkPermissions,
		async exportUsers(){
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id
			}
			const exportUsers = await projectUserExport(data)
			if(exportUsers.code == 200){
				window.open(exportUsers.url);
			}
		}
	}
};
</script>

<style scoped>
.action-btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 13px;
	border-radius: 6px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 13px;
	font-family: inherit;
	color: #666666;
	transition: background 0.15s, color 0.15s;
	white-space: nowrap;
	line-height: 1;
}
.action-btn:hover:not(:disabled) {
	opacity: 0.85;
}
.action-btn.btn-new {
	background: #2D4B95 !important;
	color: white !important;
}
.action-btn.btn-new p {
	color: white !important;
}
.action-btn.btn-new:hover:not(:disabled) {
	background: #243d7a !important;
}
.action-btn.btn-export {
	background: #5E85EF !important;
	color: white !important;
}
.action-btn.btn-export p {
	color: white !important;
}
.action-btn.btn-export:hover:not(:disabled) {
	background: #4a6fd4 !important;
}
.action-btn:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
</style>